export const RELATORIO_JOB_TIPO = {
  AUDITORIA_FAIXA: 'AUDITORIA_FAIXA',
};

export const RELATORIO_JOB_STATUS = {
  CREATED: 'CREATED',
  PROCESSING: 'PROCESSING',
  AVAILABLE: 'AVAILABLE',
  ERROR: 'ERROR',
};

export const RELATORIO_JOB_MENU_SIZE = 8;
export const RELATORIO_JOB_PAGE_SIZE = 20;
export const RELATORIO_JOB_POLL_MS = 2500;

export const isRelatorioJobInFlight = (status) =>
  status === RELATORIO_JOB_STATUS.CREATED || status === RELATORIO_JOB_STATUS.PROCESSING;

export const isRelatorioJobAvailable = (status) =>
  status === RELATORIO_JOB_STATUS.AVAILABLE;

const buildTitulo = (raw = {}) => {
  if (raw.titulo) return raw.titulo;
  if (raw.tipo === RELATORIO_JOB_TIPO.AUDITORIA_FAIXA || !raw.tipo) {
    return raw.nsirCodigo ? `Auditoria de Faixa ${raw.nsirCodigo}` : 'Auditoria de Faixa';
  }
  return raw.tipo;
};

export const normalizeRelatorioJob = (raw = {}) => ({
  id: raw.id,
  tipo: raw.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA,
  entityId: raw.entityId || raw.nsirId || null,
  status: raw.status,
  error: raw.error || null,
  titulo: buildTitulo(raw),
  nomeArquivo: raw.nomeArquivo || raw.nome || null,
  dataCriacao: raw.dataCriacao || null,
  dataAtualizacao: raw.dataAtualizacao || null,
});

export const parseRelatorioJobsPage = (body) => {
  if (!body) return { items: [], totalElements: 0 };
  if (Array.isArray(body)) {
    const items = body.map(normalizeRelatorioJob);
    return { items, totalElements: items.length };
  }
  const list = body.content || body.rows || [];
  const items = (Array.isArray(list) ? list : []).map(normalizeRelatorioJob);
  const totalElements = body.totalElements ?? body.totalRows ?? items.length;
  return { items, totalElements };
};

export const getRelatorioStatusPath = (job) => {
  if (!job || !job.id) return null;
  const tipo = job.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA;
  if (tipo === RELATORIO_JOB_TIPO.AUDITORIA_FAIXA) {
    return `reports/auditoria-faixa/${job.id}`;
  }
  return null;
};

export const getRelatorioDocumentoPath = (job) => {
  if (!job || !job.id) return null;
  const tipo = job.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA;
  if (tipo === RELATORIO_JOB_TIPO.AUDITORIA_FAIXA) {
    return `reports/auditoria-faixa/${job.id}/documento`;
  }
  return null;
};

export const getJobSubtitle = (job) => {
  if (!job) return '';
  if (isRelatorioJobInFlight(job.status)) return 'Gerando documento…';
  if (job.status === RELATORIO_JOB_STATUS.ERROR) return job.error || 'Falha ao gerar o relatório';
  return job.nomeArquivo || 'Pronto para baixar';
};
